import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {
  DEFAULT_NOTIFICATION_CONFIRM_BUTTON_LABEL,
  NotificationDialog,
  NotificationDialogDefinition
} from '@aviary/dialogs/notification-dialog/notification-dialog.types';
import {NotificationDialogComponent} from '@aviary/dialogs/notification-dialog/notification-dialog.component';

export interface SimpleNotificationDialogData {
  title: string;
  message: string;
  confirmButtonLabel?: string;
}

@Component({
  selector: 'mx-simple-notification',
  template: `
    <mx-notification-dialog [definition]="dialogDefinition"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotificationDialogComponent]
})
export class SimpleNotificationDialog implements NotificationDialog<SimpleNotificationDialogData> {

  public readonly dialogData: SimpleNotificationDialogData = inject(MAT_DIALOG_DATA);

  public readonly dialogDefinition: NotificationDialogDefinition = {
    title: this.dialogData.title,
    prompt: this.dialogData.message,
    confirmButtonLabel: this.dialogData.confirmButtonLabel ?? DEFAULT_NOTIFICATION_CONFIRM_BUTTON_LABEL
  };
}
